"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPropertyListingsInAreaAreasPropertyListingsGetRequest$ = exports.GetPropertyListingsInAreaAreasPropertyListingsGetRequest$outboundSchema = exports.GetPropertyListingsInAreaAreasPropertyListingsGetRequest$inboundSchema = exports.GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$ = exports.GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$outboundSchema = exports.GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$inboundSchema = void 0;
exports.getPropertyListingsInAreaAreasPropertyListingsGetSecurityToJSON = getPropertyListingsInAreaAreasPropertyListingsGetSecurityToJSON;
exports.getPropertyListingsInAreaAreasPropertyListingsGetSecurityFromJSON = getPropertyListingsInAreaAreasPropertyListingsGetSecurityFromJSON;
exports.getPropertyListingsInAreaAreasPropertyListingsGetRequestToJSON = getPropertyListingsInAreaAreasPropertyListingsGetRequestToJSON;
exports.getPropertyListingsInAreaAreasPropertyListingsGetRequestFromJSON = getPropertyListingsInAreaAreasPropertyListingsGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$;
(function (GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$) {
    /** @deprecated use `GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$inboundSchema` instead. */
    GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$.inboundSchema = exports.GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$inboundSchema;
    /** @deprecated use `GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$outboundSchema` instead. */
    GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$.outboundSchema = exports.GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$outboundSchema;
})(GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$ || (exports.GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$ = GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$ = {}));
function getPropertyListingsInAreaAreasPropertyListingsGetSecurityToJSON(getPropertyListingsInAreaAreasPropertyListingsGetSecurity) {
    return JSON.stringify(exports.GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$outboundSchema
        .parse(getPropertyListingsInAreaAreasPropertyListingsGetSecurity));
}
function getPropertyListingsInAreaAreasPropertyListingsGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertyListingsInAreaAreasPropertyListingsGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPropertyListingsInAreaAreasPropertyListingsGetSecurity' from JSON`);
}
/** @internal */
exports.GetPropertyListingsInAreaAreasPropertyListingsGetRequest$inboundSchema = z.object({
    "fields[listing]": z.array(shared.MultiplePropertyListingsUserFields$inboundSchema),
    "filter[address_matched]": z.boolean().optional(),
    "filter[agent_branch]": z.array(z.string()).optional(),
    "filter[agent_company]": z.array(z.string()).optional(),
    "filter[agent_id]": z.array(z.string()).optional(),
    "filter[available]": z.boolean().optional(),
    "filter[company_owned]": z.boolean().optional(),
    "filter[council_tax_band]": z.array(shared.CouncilTaxBands$inboundSchema)
        .optional(),
    "filter[energy_efficiency_current_rating]": z.array(shared.EnergyEfficiencyRatings$inboundSchema).optional(),
    "filter[exclude_properties]": z.array(z.string()).optional(),
    "filter[garden_direction]": z.array(shared.GardenDirection$inboundSchema)
        .optional(),
    "filter[has_hmo]": z.boolean().optional(),
    "filter[has_reduction]": z.boolean().optional(),
    "filter[is_bungalow]": z.boolean().optional(),
    "filter[latest_listing_only]": z.boolean().optional(),
    "filter[listing_quality]": z.array(shared.ListingQuality$inboundSchema)
        .optional(),
    "filter[listing_type]": shared.ListingType$inboundSchema.optional(),
    "filter[max_days_on_market]": z.number().int().optional(),
    "filter[max_days_since_listing]": z.number().int().optional(),
    "filter[max_days_to_renewal]": z.number().int().optional(),
    "filter[max_estimated_value]": z.number().int().optional(),
    "filter[max_estimated_value_rounded]": z.number().int().optional(),
    "filter[max_internal_area_square_metres]": z.number().int().optional(),
    "filter[max_number_of_bathrooms]": z.number().int().optional(),
    "filter[max_number_of_bedrooms]": z.number().int().optional(),
    "filter[max_outdoor_space_area_square_metres]": z.number().int().optional(),
    "filter[max_price]": z.number().int().optional(),
    "filter[max_year_built]": z.number().int().optional(),
    "filter[max_years_at_property]": z.number().int().optional(),
    "filter[min_days_on_market]": z.number().int().optional(),
    "filter[min_days_since_listing]": z.number().int().optional(),
    "filter[min_days_to_renewal]": z.number().int().optional(),
    "filter[min_estimated_value]": z.number().int().optional(),
    "filter[min_estimated_value_rounded]": z.number().int().optional(),
    "filter[min_internal_area_square_metres]": z.number().int().optional(),
    "filter[min_number_of_bathrooms]": z.number().int().optional(),
    "filter[min_number_of_bedrooms]": z.number().int().optional(),
    "filter[min_outdoor_space_area_square_metres]": z.number().int().optional(),
    "filter[min_price]": z.number().int().optional(),
    "filter[min_year_built]": z.number().int().optional(),
    "filter[min_years_at_property]": z.number().int().optional(),
    "filter[number_of_bathrooms]": z.array(z.number().int()).optional(),
    "filter[number_of_bedrooms]": z.array(z.number().int()).optional(),
    "filter[overseas_company_owned]": z.boolean().optional(),
    "filter[property_type]": z.array(shared.PropertyType$inboundSchema)
        .optional(),
    "filter[sectors]": z.array(z.string()).optional(),
    "filter[show_only_inactive_listing]": z.boolean().default(false),
    "filter[status]": z.array(shared.AreaListingStatus$inboundSchema)
        .optional(),
    "filter[tenure]": z.array(shared.TenureValues$inboundSchema).optional(),
    outcode: z.string().optional(),
    page: z.number().int().default(1),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
    sector: z.array(z.string()).optional(),
    sort: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "fields[listing]": "fieldsListing",
        "filter[address_matched]": "filterAddressMatched",
        "filter[agent_branch]": "filterAgentBranch",
        "filter[agent_company]": "filterAgentCompany",
        "filter[agent_id]": "filterAgentId",
        "filter[available]": "filterAvailable",
        "filter[company_owned]": "filterCompanyOwned",
        "filter[council_tax_band]": "filterCouncilTaxBand",
        "filter[energy_efficiency_current_rating]": "filterEnergyEfficiencyCurrentRating",
        "filter[exclude_properties]": "filterExcludeProperties",
        "filter[garden_direction]": "filterGardenDirection",
        "filter[has_hmo]": "filterHasHmo",
        "filter[has_reduction]": "filterHasReduction",
        "filter[is_bungalow]": "filterIsBungalow",
        "filter[latest_listing_only]": "filterLatestListingOnly",
        "filter[listing_quality]": "filterListingQuality",
        "filter[listing_type]": "filterListingType",
        "filter[max_days_on_market]": "filterMaxDaysOnMarket",
        "filter[max_days_since_listing]": "filterMaxDaysSinceListing",
        "filter[max_days_to_renewal]": "filterMaxDaysToRenewal",
        "filter[max_estimated_value]": "filterMaxEstimatedValue",
        "filter[max_estimated_value_rounded]": "filterMaxEstimatedValueRounded",
        "filter[max_internal_area_square_metres]": "filterMaxInternalAreaSquareMetres",
        "filter[max_number_of_bathrooms]": "filterMaxNumberOfBathrooms",
        "filter[max_number_of_bedrooms]": "filterMaxNumberOfBedrooms",
        "filter[max_outdoor_space_area_square_metres]": "filterMaxOutdoorSpaceAreaSquareMetres",
        "filter[max_price]": "filterMaxPrice",
        "filter[max_year_built]": "filterMaxYearBuilt",
        "filter[max_years_at_property]": "filterMaxYearsAtProperty",
        "filter[min_days_on_market]": "filterMinDaysOnMarket",
        "filter[min_days_since_listing]": "filterMinDaysSinceListing",
        "filter[min_days_to_renewal]": "filterMinDaysToRenewal",
        "filter[min_estimated_value]": "filterMinEstimatedValue",
        "filter[min_estimated_value_rounded]": "filterMinEstimatedValueRounded",
        "filter[min_internal_area_square_metres]": "filterMinInternalAreaSquareMetres",
        "filter[min_number_of_bathrooms]": "filterMinNumberOfBathrooms",
        "filter[min_number_of_bedrooms]": "filterMinNumberOfBedrooms",
        "filter[min_outdoor_space_area_square_metres]": "filterMinOutdoorSpaceAreaSquareMetres",
        "filter[min_price]": "filterMinPrice",
        "filter[min_year_built]": "filterMinYearBuilt",
        "filter[min_years_at_property]": "filterMinYearsAtProperty",
        "filter[number_of_bathrooms]": "filterNumberOfBathrooms",
        "filter[number_of_bedrooms]": "filterNumberOfBedrooms",
        "filter[overseas_company_owned]": "filterOverseasCompanyOwned",
        "filter[property_type]": "filterPropertyType",
        "filter[sectors]": "filterSectors",
        "filter[show_only_inactive_listing]": "filterShowOnlyInactiveListing",
        "filter[status]": "filterStatus",
        "filter[tenure]": "filterTenure",
    });
});
/** @internal */
exports.GetPropertyListingsInAreaAreasPropertyListingsGetRequest$outboundSchema = z.object({
    fieldsListing: z.array(shared.MultiplePropertyListingsUserFields$outboundSchema),
    filterAddressMatched: z.boolean().optional(),
    filterAgentBranch: z.array(z.string()).optional(),
    filterAgentCompany: z.array(z.string()).optional(),
    filterAgentId: z.array(z.string()).optional(),
    filterAvailable: z.boolean().optional(),
    filterCompanyOwned: z.boolean().optional(),
    filterCouncilTaxBand: z.array(shared.CouncilTaxBands$outboundSchema)
        .optional(),
    filterEnergyEfficiencyCurrentRating: z.array(shared.EnergyEfficiencyRatings$outboundSchema).optional(),
    filterExcludeProperties: z.array(z.string()).optional(),
    filterGardenDirection: z.array(shared.GardenDirection$outboundSchema)
        .optional(),
    filterHasHmo: z.boolean().optional(),
    filterHasReduction: z.boolean().optional(),
    filterIsBungalow: z.boolean().optional(),
    filterLatestListingOnly: z.boolean().optional(),
    filterListingQuality: z.array(shared.ListingQuality$outboundSchema)
        .optional(),
    filterListingType: shared.ListingType$outboundSchema.optional(),
    filterMaxDaysOnMarket: z.number().int().optional(),
    filterMaxDaysSinceListing: z.number().int().optional(),
    filterMaxDaysToRenewal: z.number().int().optional(),
    filterMaxEstimatedValue: z.number().int().optional(),
    filterMaxEstimatedValueRounded: z.number().int().optional(),
    filterMaxInternalAreaSquareMetres: z.number().int().optional(),
    filterMaxNumberOfBathrooms: z.number().int().optional(),
    filterMaxNumberOfBedrooms: z.number().int().optional(),
    filterMaxOutdoorSpaceAreaSquareMetres: z.number().int().optional(),
    filterMaxPrice: z.number().int().optional(),
    filterMaxYearBuilt: z.number().int().optional(),
    filterMaxYearsAtProperty: z.number().int().optional(),
    filterMinDaysOnMarket: z.number().int().optional(),
    filterMinDaysSinceListing: z.number().int().optional(),
    filterMinDaysToRenewal: z.number().int().optional(),
    filterMinEstimatedValue: z.number().int().optional(),
    filterMinEstimatedValueRounded: z.number().int().optional(),
    filterMinInternalAreaSquareMetres: z.number().int().optional(),
    filterMinNumberOfBathrooms: z.number().int().optional(),
    filterMinNumberOfBedrooms: z.number().int().optional(),
    filterMinOutdoorSpaceAreaSquareMetres: z.number().int().optional(),
    filterMinPrice: z.number().int().optional(),
    filterMinYearBuilt: z.number().int().optional(),
    filterMinYearsAtProperty: z.number().int().optional(),
    filterNumberOfBathrooms: z.array(z.number().int()).optional(),
    filterNumberOfBedrooms: z.array(z.number().int()).optional(),
    filterOverseasCompanyOwned: z.boolean().optional(),
    filterPropertyType: z.array(shared.PropertyType$outboundSchema).optional(),
    filterSectors: z.array(z.string()).optional(),
    filterShowOnlyInactiveListing: z.boolean().default(false),
    filterStatus: z.array(shared.AreaListingStatus$outboundSchema).optional(),
    filterTenure: z.array(shared.TenureValues$outboundSchema).optional(),
    outcode: z.string().optional(),
    page: z.number().int().default(1),
    point: z.array(z.string()).optional(),
    postcode: z.string().optional(),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
    sector: z.array(z.string()).optional(),
    sort: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        fieldsListing: "fields[listing]",
        filterAddressMatched: "filter[address_matched]",
        filterAgentBranch: "filter[agent_branch]",
        filterAgentCompany: "filter[agent_company]",
        filterAgentId: "filter[agent_id]",
        filterAvailable: "filter[available]",
        filterCompanyOwned: "filter[company_owned]",
        filterCouncilTaxBand: "filter[council_tax_band]",
        filterEnergyEfficiencyCurrentRating: "filter[energy_efficiency_current_rating]",
        filterExcludeProperties: "filter[exclude_properties]",
        filterGardenDirection: "filter[garden_direction]",
        filterHasHmo: "filter[has_hmo]",
        filterHasReduction: "filter[has_reduction]",
        filterIsBungalow: "filter[is_bungalow]",
        filterLatestListingOnly: "filter[latest_listing_only]",
        filterListingQuality: "filter[listing_quality]",
        filterListingType: "filter[listing_type]",
        filterMaxDaysOnMarket: "filter[max_days_on_market]",
        filterMaxDaysSinceListing: "filter[max_days_since_listing]",
        filterMaxDaysToRenewal: "filter[max_days_to_renewal]",
        filterMaxEstimatedValue: "filter[max_estimated_value]",
        filterMaxEstimatedValueRounded: "filter[max_estimated_value_rounded]",
        filterMaxInternalAreaSquareMetres: "filter[max_internal_area_square_metres]",
        filterMaxNumberOfBathrooms: "filter[max_number_of_bathrooms]",
        filterMaxNumberOfBedrooms: "filter[max_number_of_bedrooms]",
        filterMaxOutdoorSpaceAreaSquareMetres: "filter[max_outdoor_space_area_square_metres]",
        filterMaxPrice: "filter[max_price]",
        filterMaxYearBuilt: "filter[max_year_built]",
        filterMaxYearsAtProperty: "filter[max_years_at_property]",
        filterMinDaysOnMarket: "filter[min_days_on_market]",
        filterMinDaysSinceListing: "filter[min_days_since_listing]",
        filterMinDaysToRenewal: "filter[min_days_to_renewal]",
        filterMinEstimatedValue: "filter[min_estimated_value]",
        filterMinEstimatedValueRounded: "filter[min_estimated_value_rounded]",
        filterMinInternalAreaSquareMetres: "filter[min_internal_area_square_metres]",
        filterMinNumberOfBathrooms: "filter[min_number_of_bathrooms]",
        filterMinNumberOfBedrooms: "filter[min_number_of_bedrooms]",
        filterMinOutdoorSpaceAreaSquareMetres: "filter[min_outdoor_space_area_square_metres]",
        filterMinPrice: "filter[min_price]",
        filterMinYearBuilt: "filter[min_year_built]",
        filterMinYearsAtProperty: "filter[min_years_at_property]",
        filterNumberOfBathrooms: "filter[number_of_bathrooms]",
        filterNumberOfBedrooms: "filter[number_of_bedrooms]",
        filterOverseasCompanyOwned: "filter[overseas_company_owned]",
        filterPropertyType: "filter[property_type]",
        filterSectors: "filter[sectors]",
        filterShowOnlyInactiveListing: "filter[show_only_inactive_listing]",
        filterStatus: "filter[status]",
        filterTenure: "filter[tenure]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPropertyListingsInAreaAreasPropertyListingsGetRequest$;
(function (GetPropertyListingsInAreaAreasPropertyListingsGetRequest$) {
    /** @deprecated use `GetPropertyListingsInAreaAreasPropertyListingsGetRequest$inboundSchema` instead. */
    GetPropertyListingsInAreaAreasPropertyListingsGetRequest$.inboundSchema = exports.GetPropertyListingsInAreaAreasPropertyListingsGetRequest$inboundSchema;
    /** @deprecated use `GetPropertyListingsInAreaAreasPropertyListingsGetRequest$outboundSchema` instead. */
    GetPropertyListingsInAreaAreasPropertyListingsGetRequest$.outboundSchema = exports.GetPropertyListingsInAreaAreasPropertyListingsGetRequest$outboundSchema;
})(GetPropertyListingsInAreaAreasPropertyListingsGetRequest$ || (exports.GetPropertyListingsInAreaAreasPropertyListingsGetRequest$ = GetPropertyListingsInAreaAreasPropertyListingsGetRequest$ = {}));
function getPropertyListingsInAreaAreasPropertyListingsGetRequestToJSON(getPropertyListingsInAreaAreasPropertyListingsGetRequest) {
    return JSON.stringify(exports.GetPropertyListingsInAreaAreasPropertyListingsGetRequest$outboundSchema
        .parse(getPropertyListingsInAreaAreasPropertyListingsGetRequest));
}
function getPropertyListingsInAreaAreasPropertyListingsGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPropertyListingsInAreaAreasPropertyListingsGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPropertyListingsInAreaAreasPropertyListingsGetRequest' from JSON`);
}
//# sourceMappingURL=getpropertylistingsinareaareaspropertylistingsget.js.map